var React = require('react');

function Magnifier16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=16x16, Invert=On","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"id":"Ellipse 1","cx":"6.496","cy":"6.496","r":"5.496","key":0}),React.createElement("path",{"id":"Vector 160","d":"M10.737 10.737l4.42 4.42","key":1})]));
}

Magnifier16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Magnifier16x16;

Magnifier16x16.default = Magnifier16x16;
